import {
  engWVsAusWU19COntestListByCategoryList,
  indiaVsNewzealandContestByCategoryList,
  indVsNzT20ContestByCategoryList,
  indWVsNzWU19COntestListByCategoryList,
  saVsEngContestByCategoryList,
  saWVsIndWContestListByCategoryList,
  wiWVsIndWT20ContestByCategoryList
} from './fantasy_cricket_contestbycategory';
import {
  engWVsAusWU19LeaderBoardData,
  indVsNzT20LeaderBoardData,
  indVsSaT20LeaderBoardData,
  indVsSlTestLeaderBoardData,
  indVsZimLeaderBoardData,
  indWVsNzWU19LeaderBoardData,
  pakVsAusLeaderBoardData,
  pakVsNzLeaderBoardData,
  saVsEngLeaderBoardData,
  saWVsIndWLeaderBoardData,
  slVsAfgT20LeaderBoardData,
  wiVsEngLeaderBoardData,
  wiWVsIndWLeaderBoardData
} from './fantasy_cricket_leaderboard';
import {
  engWVsAusWU19Match,
  indVsNzT20Match,
  indVsSaT20Match,
  indVsSlTestMatch,
  indVsZimMatch,
  indWVsNzWU19Match,
  nzVsPakMatch,
  saVsEngOdiMatch,
  saWVsIndWMatch,
  slVsAfgT20Match,
  wiWVsIndWT20Match
} from './fantasy_cricket_matches';
import {
  engWVsAusWU19MyContestList,
  indiaVsNewzealandMyContestList,
  indVsNzT20MyContestList,
  indVsSaT20MyContestList,
  indVsSlTestMyContestList,
  indVsZimMyContestList,
  indWVsNzWU19MyContestList,
  pakVsAusMyContestList,
  pakVsNzMyContestList,
  saVsEngMyContestList,
  saWVsIndWMyContestList,
  slVsAfgT20MyContestList,
  wiVsEngMyContestList,
  wiWVsIndWT20MyContestList
} from './fantasy_cricket_myContestList';
import {
  engWVsAusWU19PlayerList,
  indiaVsNewzealandPlayerList,
  indVsNzT20PlayerList,
  indVsSaT20PlayerList,
  indVsSlTestPlayerList,
  indVsZimPlayerList,
  indWVsNzWU19PlayersList,
  pakVsAusPlayerList,
  pakVsNzPlayerList,
  saVsEngPlayerList,
  saWVsIndWPlayersList,
  slVsAfgT20PlayerList,
  wiVsEngPlayerList,
  wiWVsIndWT20PlayerList
} from './fantasy_cricket_playerlist';
import {
  engWVsAusWU19MyTeamsList,
  indiaVsNewzealandTeamsList,
  indVsNzT20MyTeamsList,
  indVsSaT20MyTeamsList,
  indVsSlTestMyTeamsList,
  indVsZimMyTeamsList,
  indWVsNzWU19MyTeamsList,
  pakVsAusTeamsList,
  pakVsNzMyTeamsList,
  saVsEngMyTeamsList,
  saWVsIndWMyTeamsList,
  slVsAfgT20MyTeamsList,
  wiVsEngMyTeamsList,
  wiWVsIndWT20MyTeamsList
} from './fantasy_cricket_teamslist';

export const fantasyCricketInitialFixtureMatchList = [
  saVsEngOdiMatch,
  indVsNzT20Match,
  wiWVsIndWT20Match,
  engWVsAusWU19Match,
  saWVsIndWMatch,
  indWVsNzWU19Match
];
export const fantasyCricketInitialResultsMatchList = [
  {
    _id: '62487289bc54653691c41e41',
    apiMatchId: '51413',
    competition: {
      cid: 122123,
      title: 'Australia tour of Pakistan',
      abbr: 'ATOP',
      type: 'tour',
      category: 'international',
      match_format: 'mixed',
      status: 'live',
      season: '2022',
      datestart: '2022-03-03',
      dateend: '2022-04-05',
      country: 'int',
      total_matches: '7',
      total_rounds: '3',
      total_teams: '2'
    },
    competitionTypeId: '6094d1232484deb6cdcce47f',
    createdOn: '2022-04-02T15:58:01.141Z',
    endDate: '2022-04-06T01:30:00.000Z',
    formatString: 'T20I',
    gameState: 0,
    gameStateText: 'Default',
    lineupsOut: true,
    preSquad: true,
    result: {},
    startDate: '2022-04-05T15:30:00.000Z',
    status: 2,
    statusText: 'Completed',
    subtitle: 'Only T20I',
    teamA: {
      team_id: 13,
      name: 'Pakistan',
      short_name: 'PAK',
      logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Pakistan.png'
    },
    teamB: {
      team_id: 5,
      name: 'Australia',
      short_name: 'AUS',
      logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/Australia.png'
    },
    timestampEnd: 1649208600,
    timestampStart: 1649172600,
    title: 'Pakistan vs Australia',
    venue: {
      venue_id: '93',
      name: 'Rawalpindi Cricket Stadium',
      location: 'Rawalpindi',
      timezone: '-12'
    },
    verified: true,
    isContestListed: true,
    modifiedOn: '2022-04-05T19:04:00.024Z'
  },
  {
    _id: '622ae1a182f394e16728d732',
    apiMatchId: '51810',
    competition: {
      cid: 122328,
      title: 'England tour of West Indies',
      abbr: 'ETOWI',
      type: 'tournament',
      category: 'international',
      match_format: 'mixed',
      status: 'live',
      season: '2022',
      datestart: '2022-01-22',
      dateend: '2022-03-28',
      country: 'int',
      total_matches: '9',
      total_rounds: '3',
      total_teams: '3'
    },
    competitionTypeId: '6094d1232484deb6cdcce481',
    createdOn: '2022-03-11T05:44:01.076Z',
    endDate: '2022-03-21T14:00:00.000Z',
    formatString: 'Test',
    gameState: 0,
    gameStateText: 'Default',
    lineupsOut: true,
    preSquad: true,
    result: {},
    startDate: '2022-03-16T14:00:00.000Z',
    status: 2,
    statusText: 'Completed',
    subtitle: '2nd Test',
    teamA: {
      team_id: 17,
      name: 'West Indies',
      short_name: 'WI',
      logo_url:
        'https://images.entitysport.com/assets/uploads/2020/03/west-indies-over-50s-32x32.png'
    },
    teamB: {
      team_id: 490,
      name: 'England',
      short_name: 'ENG',
      logo_url: 'https://images.entitysport.com/assets/uploads/2020/12/England.png'
    },
    timestampEnd: 1647871200,
    timestampStart: 1647439200,
    title: 'West Indies vs England',
    venue: {
      venue_id: '36',
      name: 'Kensington Oval, Bridgetown, Barbados',
      location: 'Bridgetown',
      timezone: '-12'
    },
    verified: true,
    isContestListed: true,
    modifiedOn: '2022-03-20T22:08:00.023Z'
  },
  indVsSlTestMatch,
  indVsSaT20Match,
  slVsAfgT20Match
];
export const fantasyCricketInitialLiveMatchList = [nzVsPakMatch, indVsZimMatch];

export const fantasyCricketContestByCategoryList = {
  '63cbb6ed96851a4d7f84726c': indiaVsNewzealandContestByCategoryList,
  '63d0d9c596851a4d7f67dcd5': saVsEngContestByCategoryList,
  '63cf79bd96851a4d7f28b245': indVsNzT20ContestByCategoryList,
  '63cc017596851a4d7f92dbc2': wiWVsIndWT20ContestByCategoryList,
  '63d166dc96851a4d7f804920': engWVsAusWU19COntestListByCategoryList,
  '63cbff1d96851a4d7f92725d': saWVsIndWContestListByCategoryList,
  '63d1792496851a4d7f831eb1': indWVsNzWU19COntestListByCategoryList
};

export const fantasyCricketMyContestList = {
  '63cbb6ed96851a4d7f84726c': indiaVsNewzealandMyContestList,
  '62487289bc54653691c41e41': pakVsAusMyContestList,
  '63be86840901e17d0f43117e': pakVsNzMyContestList,
  '622ae1a182f394e16728d732': wiVsEngMyContestList,
  '63d0d9c596851a4d7f67dcd5': saVsEngMyContestList,
  '63cf79bd96851a4d7f28b245': indVsNzT20MyContestList,
  '6225783d17d940379f6d67d1': indVsSlTestMyContestList,
  '63344fdc258445b807480bf7': indVsSaT20MyContestList,
  '630727157e2d41535f39f628': slVsAfgT20MyContestList,
  '63cc017596851a4d7f92dbc2': wiWVsIndWT20MyContestList,
  '62fdf2711f7aacc4e352a767': indVsZimMyContestList,
  '63d166dc96851a4d7f804920': engWVsAusWU19MyContestList,
  '63cbff1d96851a4d7f92725d': saWVsIndWMyContestList,
  '63d1792496851a4d7f831eb1': indWVsNzWU19MyContestList
};

export const fantasyCricketInitialTeamsList = {
  '63cbb6ed96851a4d7f84726c': indiaVsNewzealandTeamsList,
  '62487289bc54653691c41e41': pakVsAusTeamsList,
  '63be86840901e17d0f43117e': pakVsNzMyTeamsList,
  '622ae1a182f394e16728d732': wiVsEngMyTeamsList,
  '63d0d9c596851a4d7f67dcd5': saVsEngMyTeamsList,
  '63cf79bd96851a4d7f28b245': indVsNzT20MyTeamsList,
  '6225783d17d940379f6d67d1': indVsSlTestMyTeamsList,
  '63344fdc258445b807480bf7': indVsSaT20MyTeamsList,
  '630727157e2d41535f39f628': slVsAfgT20MyTeamsList,
  '63cc017596851a4d7f92dbc2': wiWVsIndWT20MyTeamsList,
  '62fdf2711f7aacc4e352a767': indVsZimMyTeamsList,
  '63d166dc96851a4d7f804920': engWVsAusWU19MyTeamsList,
  '63cbff1d96851a4d7f92725d': saWVsIndWMyTeamsList,
  '63d1792496851a4d7f831eb1': indWVsNzWU19MyTeamsList
};

export const fantasyCricketInitialPlayerList = {
  '63cbb6ed96851a4d7f84726c': indiaVsNewzealandPlayerList,
  '62487289bc54653691c41e41': pakVsAusPlayerList,
  '63be86840901e17d0f43117e': pakVsNzPlayerList,
  '622ae1a182f394e16728d732': wiVsEngPlayerList,
  '63d0d9c596851a4d7f67dcd5': saVsEngPlayerList,
  '63cf79bd96851a4d7f28b245': indVsNzT20PlayerList,
  '6225783d17d940379f6d67d1': indVsSlTestPlayerList,
  '63344fdc258445b807480bf7': indVsSaT20PlayerList,
  '630727157e2d41535f39f628': slVsAfgT20PlayerList,
  '63cc017596851a4d7f92dbc2': wiWVsIndWT20PlayerList,
  '62fdf2711f7aacc4e352a767': indVsZimPlayerList,
  '63d166dc96851a4d7f804920': engWVsAusWU19PlayerList,
  '63cbff1d96851a4d7f92725d': saWVsIndWPlayersList,
  '63d1792496851a4d7f831eb1': indWVsNzWU19PlayersList
};

export const fantasyCricketLeaderBoardData = {
  '62487289bc54653691c41e41': pakVsAusLeaderBoardData,
  '622ae1a182f394e16728d732': wiVsEngLeaderBoardData,
  '63d0d9c596851a4d7f67dcd5': saVsEngLeaderBoardData,
  '63be86840901e17d0f43117e': pakVsNzLeaderBoardData,
  '63cf79bd96851a4d7f28b245': indVsNzT20LeaderBoardData,
  '6225783d17d940379f6d67d1': indVsSlTestLeaderBoardData,
  '63344fdc258445b807480bf7': indVsSaT20LeaderBoardData,
  '630727157e2d41535f39f628': slVsAfgT20LeaderBoardData,
  '62fdf2711f7aacc4e352a767': indVsZimLeaderBoardData,
  '63d166dc96851a4d7f804920': engWVsAusWU19LeaderBoardData,
  '63cc017596851a4d7f92dbc2': wiWVsIndWLeaderBoardData,
  '63cbff1d96851a4d7f92725d': saWVsIndWLeaderBoardData,
  '63d1792496851a4d7f831eb1': indWVsNzWU19LeaderBoardData
};

export const fantasyCricketAllContestList = {};
